/* Mobile sticky add-to-cart bar: shown whenever the main add-to-cart button is not on screen
   (scrolled past it, or still below the fold), always above the bottom bar. */
(function () {
  var bar = document.querySelector('[data-sticky-atc]');
  var main = document.querySelector('[data-atc]');
  if (!bar || !main || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    bar.classList.toggle('show', !entries[0].isIntersecting);
  }, { rootMargin: '0px 0px -64px 0px' });
  io.observe(main);
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sticky-submit]');
    if (!b) return;
    var form = document.querySelector('[data-product-form]');
    if (form) form.requestSubmit();
  });
})();
